module.exports = __webpack_public_path__ + "assets/payments.dcdc67b439c3e111478e8f688c497535.svg";